import { Link } from 'react-router-dom';

function Info() {

    const divCenteredeInfoStyle = {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        // justifyContent: 'center',
        // alignItems: 'center',
        flexDirection: 'column',
        height: '100vh',
        // margin: top right bottom left
        margin: '50px 60px 20px 60px',
        overflowX: 'hidden',
        overflowY: 'auto',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        borderRadius: '10px',
    };

    // divInner should start in the top left corner of the parent div
    const divInner = {
        padding: '40px',
    }

    const h1Style = {
        color: 'white',
        fontSize: '30px'
    }

    const pStyle = {
        color: 'white',
        fontSize: '20px'
    }


    return (
        <div style={divCenteredeInfoStyle}>
            <div style={divInner}>
                <div>
                    <h1 style={h1Style}>Information Page</h1>
                </div>
                <p style={pStyle}>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Soluta, natus non, nesciunt quod deserunt nostrum perspiciatis praesentium sint minus consectetur a necessitatibus perferendis maxime architecto adipisci. Nemo vero eligendi illum? Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit voluptatum, suscipit odit a voluptate necessitatibus aperiam molestiae? Ipsam laboriosam quos qui debitis soluta saepe tenetur. Dolorum nam consequuntur debitis commodi.</p>
                <Link to="/">Back to Home</Link>
            </div>
        </div>
    );
};


export default Info;
